import React, { useState, useEffect } from "react";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import { useReferalProgramsDataContext } from "@/store/ReferalProgramsProvider";
import { useEarningsDataContext } from "@/store/EarningsProvider";
import { FirstLoader } from "@/ui/ContainerLoader/FirstLoader";
import { useMultiplierDataContext } from "@/store/MultiplierProvider";

export default function LoaderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { referalsLoading } = useReferalsDataContext();
  const { referalProgramsLoading } = useReferalProgramsDataContext();
  const { earningsLoading } = useEarningsDataContext();
  const { multiplierLoading } = useMultiplierDataContext();

  const isLoading =
    referalsLoading ||
    referalProgramsLoading ||
    earningsLoading ||
    multiplierLoading;

  const [progress, setProgress] = useState(0);
  const [showFirstLoader, setShowFirstLoader] = useState(true);

  useEffect(() => {
    if (!isLoading) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 10;
      });
    }, 300);

    return () => clearInterval(interval);
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      setProgress(100);

      const timeout = setTimeout(() => {
        setShowFirstLoader(false);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (showFirstLoader) return <FirstLoader progress={progress} />;

  if (isLoading && !showFirstLoader) return <ContainerLoader />;

  return children;
}
